export const COMMODITY_CREATE_REQUESTED = 'COMMODITY_CREATE_REQUESTED';
export const COMMODITY_CREATE_SUCCEEDED = 'COMMODITY_CREATE_SUCCEEDED';
export const COMMODITY_CREATE_FAILED = 'COMMODITY_CREATE_FAILED';

export const COMMODITIES_SET = 'COMMODITIES_SET';

export const COMMODITY_CREATE_NAMESPACE = 'COMMODITY_CREATE';

export const COMMODITY_UPDATE_NAMESPACE = 'COMMODITY_UPDATE';
export const COMMODITY_UPDATE_REQUESTED = 'COMMODITY_UPDATE_REQUESTED';
export const COMMODITY_UPDATE_SUCCEEDED = 'COMMODITY_UPDATE_SUCCEEDED';
export const COMMODITY_UPDATE_FAILED = 'COMMODITY_UPDATE_FAILED';

export const COMMODITY_DELETE_NAMESPACE = 'COMMODITY_DELETE';
export const COMMODITY_DELETE_REQUESTED = 'COMMODITY_DELETE_REQUESTED';
export const COMMODITY_DELETE_SUCCEEDED = 'COMMODITY_DELETE_SUCCEEDED';
export const COMMODITY_DELETE_FAILED = 'COMMODITY_DELETE_FAILED';

export const COMMODITIES_REMOVE = 'COMMODITIES_REMOVE';
